import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const cpm = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "CPM Partnerwerkstätten in Ihrer Nähe",
      hero: {
        title: "Willkommen bei der Werkstatt-Buchung </br> von CPM",
      },
      layout: {
        backText: "Zurück zu carprofessional.de",
        navbar: {
          partnerLogo: {
            alt: "CPM",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/cpm",
    },
  },
};
